var _defs, _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteps03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Growing_Earnings",
    "data-name": "Growing Earnings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #df4f71;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: rgba(223, 79, 113, .2);\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    "data-name": "Vector 6",
    className: "cls-2",
    d: "M31,31h-6V14.2c0-.318.126-.623.351-.849.225-.225.53-.351.849-.351h3.6c.318,0,.624.126.849.351.225.225.351.53.351.849,0,0,0,16.8,0,16.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    "data-name": "Vector 7",
    className: "cls-2",
    d: "M19,31h-6v-13.2c0-.318.126-.623.351-.849.225-.225.53-.351.849-.351h3.6c.318,0,.623.126.849.351.225.225.351.53.351.849,0,0,0,13.2,0,13.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    "data-name": "Vector 8",
    className: "cls-2",
    d: "M7,31H1v-9.6c0-.318.126-.623.351-.849.225-.225.53-.351.849-.351h3.6c.318,0,.623.126.849.351.225.225.351.53.351.849v9.6Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "cls-1",
    d: "M2.224,15.496L29.824,2.944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    "data-name": "Vector 2",
    className: "cls-1",
    d: "M24.664,1l5.16,1.944-1.92,5.16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps03);
export default __webpack_public_path__ + "static/media/steps-03.45bfb9f0ac7e1e31cc4530e06e9c6093.svg";
export { ForwardRef as ReactComponent };